import { ajax as request } from '@blade/common';
/** ==============================@Description: 任务管理============================== */
/**
*@Description: 添加任务
*@Date: 2020-09-01 14:39:57
*/
export const postTask = (data) => request({
    url: '/api/task-management/api/v1/combined/task',
    method: 'POST',
    data
});
/**
*@Description: 布控任务详情
*@Date: 2020-09-01 14:39:57
*/
export const getTaskDetail = (id) => request({
    url: '/api/task-management/api/v1/combined/task/' + id,
    method: 'GET'
});
/**
*@Description: 修改任务
*@Date: 2020-09-01 14:39:57
*/
export const putTargetsDetail = (data) => request({
    url: '/api/task-management/api/v1/combined/task',
    method: 'PUT',
    data
});
/**
*@Description: 删除任务
*@Date: 2020-09-01 14:39:57
*/
export const deleteTargetsDetail = (targetId) => request({
    url: '/api/task-management/api/v1/combined/task/' + targetId,
    method: 'DELETE'
});
/**
*@Description: 任务列表
*@Date: 2020-09-01 14:39:57
*/
export const getTaskList = (data) => request({
    url: '/api/task-management/api/v1/combined/task/list',
    method: 'POST',
    data
});
